import Vue from 'vue';
import Router from 'vue-router';
import TermsAndConditions from '../views/main/TermsAndConditions.vue';
import Login from '../views/accounts/Login.vue';
import AccountDetail from '../views/accounts/AccountDetail.vue';
import PasswordReset from '../views/accounts/PasswordReset.vue';
import Employers from '../views/dashboard/Employees.vue';
import Tariffs from '../views/dashboard/Tariffs.vue';
import SIMCards from '../views/dashboard/SIMCards.vue';
import Dealers from '../views/dashboard/Dealers.vue';
import Dashboard from '../views/dashboard/Dashboard.vue';
import Subscriptions from '../views/dashboard/Subscriptions.vue';
import Checkout from '../views/main/Checkout.vue';
import CheckoutDone from '../views/main/CheckoutDone.vue';
import Services from '../views/main/Services.vue';
import Subscribers from '../views/dashboard/Subscribers.vue';
import Reports from '../views/dashboard/Reports.vue';
import Finance from '../views/dashboard/Finance.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      // component: Home,
      redirect: '/dashboard',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Главная страница - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        title: 'Отчеты - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance,
      meta: {
        title: 'Платежи - PaySim ',
        requiresAuth: true,
      },
    },
    {
      path: '/employees',
      name: 'employees',
      component: Employers,
      meta: {
        title: 'Сотрудники - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/subscribers',
      name: 'subscribers',
      component: Subscribers,
      meta: {
        title: 'Подписчики - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/dealers',
      name: 'dealers',
      component: Dealers,
      meta: {
        title: 'Дилеры - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/tariffs',
      name: 'tariffs',
      component: Tariffs,
      meta: {
        title: 'Тарифы - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
      meta: {
        title: 'Абоненты - PaySim ',
        requiresAuth: true,
      },
    },
    {
      path: '/sim-card',
      name: 'sim-card',
      component: SIMCards,
      meta: {
        title: 'Новые номера - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Вход - PaySim',
      },
    },
    {
      path: '/checkout',
      name: 'checkout',
      props: true,
      component: Checkout,
      meta: {
        title: 'Оплата - PaySim',
      },
    },
    {
      path: '/checkout/done',
      name: 'checkout-done',
      props: true,
      component: CheckoutDone,
      meta: {
        title: 'Проверка оплаты - PaySim',
      },
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: PasswordReset,
      meta: {
        title: 'Сброс пароля - PaySim',
      },
    },
    {
      path: '/account',
      name: 'account',
      component: AccountDetail,
      meta: {
        title: 'Данные пользователя - PaySim',
        requiresAuth: true,
      },
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: TermsAndConditions,
      meta: {
        title: 'Условия предоставления услуг - PaySim',
      },
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      meta: {
        title: 'Наши услуги - PaySim',
      },
    },
    // otherwise redirect to home
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});


router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('token')) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
